

export default class UpdatePromoCodeRequest  {
	Id?: number = null;
	Code?: string = '';
	PremiumDays: number = 0;
	IsSingleUse: boolean = false;
	ExpirationDate: Date = null;
	constructor(obj?: Partial<UpdatePromoCodeRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
